<ion-modal
  #simpleSearchModalRef
  [isOpen]="isOpen"
  (ionModalDidDismiss)="onDismiss($event)"
  [ngClass]="
    platformService.platformType !== platformService.platformEnum.desktop
      ? 'ion-modal-touch'
      : 'new-search-simple-modal'
  "
  [initialBreakpoint]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? 1
      : undefined
  "
  [breakpoints]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? [0, 1]
      : undefined
  "
>
  <ng-template>
    <ion-header
      *ngIf="
        platformService?.platformType === platformService?.platformEnum?.desktop
      "
    >
      <ion-toolbar>
        <ion-buttons slot="end">
          <ion-button (click)="onClose()">
            <ion-icon slot="icon-only" name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <ion-label>
        {{
          (platformService?.platformType ===
            platformService?.platformEnum?.desktop ||
          platformService?.platformType ===
            platformService?.platformEnum?.tablet
            ? 'i18n.header.newSearchProductCatalog'
            : 'i18n.header.searchProducts'
          ) | translate
        }}
      </ion-label>
      <ion-searchbar
        class="new-simple-search"
        enterkeyhint="search"
        mode="md"
        placeholder="{{ 'i18n.header.newSearchCatalog' | translate }}"
        (keydown.enter)="executeSearch()"
        (ionInput)="handleInputChange($event)"
      ></ion-searchbar>
    </ion-content>

    <ion-footer
      class="ion-footer-modal"
      *ngIf="
        platformService?.platformType === platformService?.platformEnum?.desktop
      "
    >
      <ion-toolbar>
        <ion-buttons>
          <ion-button
            [ngClass]="'usf-outline-green-dsktp-tblt-modal-button'"
            (click)="onClose()"
          >
            {{ 'i18n.common.cancel' | translate }}
          </ion-button>
          <ion-button
            [ngClass]="
              inputText?.length > 0
                ? 'usf-fill-green-dsktp-tblt-modal-button'
                : 'usf-fill-disabled-dsktp-tblt-modal-button'
            "
            (click)="executeSearch()"
          >
            {{ 'i18n.header.search' | translate }}
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal>
